/**
 * @typedef { import('../../time.js').YearMonthPeriod } YearMonthPeriod
 * @typedef { import('../../time.js').YearMonthPeriodObject } YearMonthPeriodObject
 * @typedef { import('../../time.js').YearMonth } YearMonth
 * @typedef { import('./retention_report.js').Report } Report
 * @typedef { import('./retention_report.js').Cohort } Cohort
 */

/**
 * @param {Report} report
 * @returns {string}
 */
export function convertRetentionReportToTriangleString(report) {
  let str = "cohort,size\n";

  const period = report.getPeriod();

  const beginMonth = period.getBegin();
  const endMonth   = period.getEnd();

  for(let month = beginMonth; month.isBefore(endMonth); month = month.getNext()) {
    const cohort = report.getCohortByMonth(month);
    const cohortStr = convertCohortToString(cohort, endMonth);
    str += cohortStr + "\n";
  }

  return str;
}

/**
 * @param {Cohort} cohort
 * @param {YearMonth} endMonth
 * @returns {string}
 */
function convertCohortToString(cohort, endMonth) {
  const parts = [];

  parts.push(cohort.getName());
  parts.push(cohort.getSize().toString());

  const metricStr = convertMetricsToString(cohort, endMonth);
  if(metricStr.length > 0) {
    parts.push(metricStr);
  }
  return parts.join(',');
}

/**
 * @param {Cohort} cohort
 * @param {YearMonth} endMonth
 * @returns {string}
 */
function convertMetricsToString(cohort, endMonth) {
  /** @type {string[]} */
  const valueStrs = [];

  const metricBeginMonth = cohort.getYearMonth().getNext();
  for(let month = metricBeginMonth; month.isBefore(endMonth); month = month.getNext()) {
    const value = cohort.getMetricValueByMonth(month);
    valueStrs.push(value.toString());
  }

  return valueStrs.join(',');
}
